import React from "react";
import FormMaxError from "../../errors/FormMaxError";

export default class WebsiteMaxError extends React.Component {
    render() {
        return <FormMaxError field_name={this.props.error.slice(0, -4)} max={100} />
    }
}
